/**
 * fusionMsiBrandConfig.js — today's FusionMSI marketing chrome, as data.
 * Shaped by: md3c step 4b.
 * Invariants: hrefs are resolved when this is called, because isFusionMsiHost()
 * reads localStorage after import. Header tagline and byline stay unset.
 * Footer entity, address, and copyright stay empty. Caption and location note
 * are the strings the layout rendered before this config existed.
 * Related: fusionMsiMarketingTokens.js, FusionMsiMarketingNav.jsx,
 * FusionMsiMarketingLayout.jsx, decisionPointMarketingData.js.
 */
import { FOOTER_DISCLOSURE } from './decisionPointMarketingData';
import {
  aboutPath,
  audiencePagePath,
  businessModelPath,
  careStartSponsorPath,
  historicalPrecedentPath,
  marketingHubPath,
  platformHubPath,
} from './fusionMsiMarketingRouting';

/** Same sentence the layout hard-coded beside the provisional disclosure. */
export const FUSION_MSI_LOCATION_NOTE =
  'This site may ask for your device location once to suggest a relevant regional page. ' +
  'Location is used only in your browser for that suggestion and is not stored or sent to our servers.';

/** FusionMSI chrome values. Call at render time so / and /dp stay host-aware. */
export function getFusionMsiBrandConfig() {
  return {
    wordmark: 'FusionMSI',
    homeHref: marketingHubPath(),
    navItems: [
      { label: 'Home', href: marketingHubPath(), external: false },
      { label: 'Patients', href: audiencePagePath('patient'), external: false },
      { label: 'Clinicians', href: audiencePagePath('clinician'), external: false },
      { label: 'Care Sites', href: audiencePagePath('facility'), external: false },
      { label: 'Governance Roles', href: audiencePagePath('fde'), external: false },
      { label: 'Platform', href: platformHubPath(), external: false, activePrefix: true },
      { label: 'Business model', href: businessModelPath(), external: false },
      { label: 'Sponsors', href: careStartSponsorPath(), external: false },
      { label: 'Historical precedent', href: historicalPrecedentPath(), external: false },
      { label: 'About', href: aboutPath(), external: false },
    ],
    footer: {
      entityLine: '',
      address: '',
      copyright: '',
      caption: FOOTER_DISCLOSURE,
      locationNote: FUSION_MSI_LOCATION_NOTE,
      links: [],
    },
    favicon: {
      svg: '/brand/fusionmsi/favicon.svg',
      png: '/brand/fusionmsi/favicon-64.png',
      apple: '/brand/fusionmsi/app-icon-180.png',
    },
    ogImage: '/brand/fusionmsi/og-image.png',
    title: 'FusionMSI',
  };
}
